export default __webpack_public_path__ + "static/media/1408.3c9b91dd.png";